const DEFAULT_SITE_URL = "https://mutzur.de";
const DEFAULT_SOCIAL_IMAGE_PATH = "/images/laptop.webp";

function normalizeAbsoluteUrl(value?: string) {
  if (!value) {
    return "";
  }

  try {
    return new URL(value).toString().replace(/\/+$/, "");
  } catch {
    return "";
  }
}

export function getSiteOrigin() {
  const configuredOrigin = normalizeAbsoluteUrl(import.meta.env.VITE_SITE_URL);

  if (configuredOrigin) {
    return configuredOrigin;
  }

  if (typeof window !== "undefined" && window.location.origin) {
    return window.location.origin;
  }

  return DEFAULT_SITE_URL;
}

export function getAbsoluteUrl(path = "/") {
  return new URL(path, `${getSiteOrigin()}/`).toString();
}

export function getDefaultSocialImageUrl() {
  return getAbsoluteUrl(DEFAULT_SOCIAL_IMAGE_PATH);
}
